module.exports = __webpack_public_path__ + "static/media/001-mobile.8cef7ae5.webp";